var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9019 16.7944C13.4842 17.6933 11.8028 18.2139 9.99993 18.2139C5.50644 18.2139 1.76813 14.9807 0.984375 10.7139C1.34828 8.73273 2.34911 6.97446 3.76673 5.65918L1.16106 3.05352L2.33957 1.875L18.8388 18.3741L17.6603 19.5527L14.9019 16.7944ZM4.94601 6.83846C3.83862 7.84717 3.03118 9.18638 2.68533 10.7139C3.44986 14.0905 6.47018 16.5472 9.99993 16.5472C11.3328 16.5472 12.593 16.1969 13.6866 15.579L11.9963 13.8888C11.4183 14.253 10.7337 14.4639 9.99993 14.4639C7.92883 14.4639 6.24989 12.7849 6.24989 10.7139C6.24989 9.98004 6.46065 9.29546 6.82493 8.71739L4.94601 6.83846ZM10.7613 12.6537L8.06006 9.95254C7.96743 10.1884 7.91656 10.4451 7.91656 10.7139C7.91656 11.8645 8.84934 12.7972 9.99993 12.7972C10.2686 12.7972 10.5254 12.7463 10.7613 12.6537ZM17.3387 14.5408L16.1463 13.3485C16.6929 12.5694 17.0958 11.6792 17.3144 10.7139C16.5499 7.33719 13.5296 4.88051 9.99993 4.88051C9.29501 4.88051 8.61043 4.97848 7.96008 5.16219L6.64506 3.84717C7.68407 3.43837 8.81576 3.21384 9.99993 3.21384C14.4933 3.21384 18.2317 6.44698 19.0154 10.7139C18.7553 12.1302 18.1695 13.4327 17.3387 14.5408ZM9.76876 6.97085C9.84518 6.9662 9.92226 6.96384 9.99993 6.96384C12.0709 6.96384 13.7499 8.64278 13.7499 10.7139C13.7499 10.7915 13.7475 10.8685 13.7429 10.945L9.76876 6.97085Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyeIcon);
export default __webpack_public_path__ + "static/media/close-eye-icon.4fcab77cccbf321e67e5af3886a18696.svg";
export { ForwardRef as ReactComponent };